import { TweenAction } from './TweenAction';
import Phaser from 'phaser';

export class TweenSequenceAction {
  private scene: Phaser.Scene;
  private tweenActions: TweenAction[];
  private loop: number = 0;
  private onComplete = () => {};
  private timeline: Phaser.Tweens.Timeline | undefined;

  constructor(scene: Phaser.Scene, ...tweenActions: TweenAction[]) {
    this.scene = scene;
    this.tweenActions = tweenActions;
  }

  add(tweenAction: TweenAction) {
    this.tweenActions.push(tweenAction);
  }

  setLoop(loop) {
    this.loop = loop;
    return this;
  }

  setOnComplete(onComplete) {
    this.onComplete = onComplete;
    return this;
  }

  run() {
    this.timeline = this.scene.tweens.createTimeline();
    for (const tweenAction of this.tweenActions) {
      this.timeline.add(tweenAction.getTweenConfig());
    }

    this.timeline.loop = this.loop;
    this.timeline.addListener(Phaser.Tweens.Events.TIMELINE_COMPLETE, this.onComplete);
    this.timeline.play();
  }

  stop() {
    if (this.timeline) {
      this.timeline.stop();
    }
  }

  destroy() {
    if (this.timeline) {
      this.timeline.destroy();
    }
  }
}